export default function MySQL_LOCATE() {
  return (
    <div>
      <h2>MySQL_LOCATE</h2>    </div>
  );
}